import isObject from 'lodash/isObject';

export class StorageService {
  setItem(storageKey, value, isPersistent = false) {
    const storage = isPersistent ? localStorage : sessionStorage;

    isObject(value)
      ? storage.setItem(storageKey, JSON.stringify(value))
      : storage.setItem(storageKey, String(value));
  }

  getItem(storageKey) {
    const localStorageItem = localStorage.getItem(storageKey);

    if (localStorageItem) {
      return this._getValue(localStorageItem);
    }

    const sessionStorageItem = sessionStorage.getItem(storageKey);

    if (sessionStorageItem) {
      return this._getValue(sessionStorageItem);
    }
  }

  removeItem(storageKey) {
    localStorage.removeItem(storageKey);
    sessionStorage.removeItem(storageKey);
  }

  clear() {
    localStorage.clear();
    sessionStorage.clear();
  }

  hasItem(storageKey) {
    return Boolean(this.getItem(storageKey));
  }

  _getValue(value) {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
}
